addEventListener('DOMContentLoaded', _=> {
    if (document.getElementById('car-image') !== null) {
        // SCOLL DIRECTION STUFF
        let oldScroll = window.scrollY
        let scrollDirection = 'unset'

        addEventListener('scroll', _=> {
            scrollDirection = scrollDirectionCheck()
        })

        function scrollDirectionCheck() {
            let windowScroll = window.scrollY
            if (oldScroll !== null) {
                if (windowScroll <= oldScroll) {
                    oldScroll = windowScroll
                    return 'up'
                } else {
                    oldScroll = windowScroll
                    return 'down'
                }
            }
        }

        //OBSERVER STUFF
        const carImage = document.getElementById('car-image')
        const carObserver = new IntersectionObserver(entries => {
            entries.forEach(element => {
                let elementChild = element.target.children[0]
                if (scrollDirection === 'down') {
                    if (!elementChild.classList.contains('leaving') && !elementChild.classList.contains('entering')) {
                        elementChild.classList.add('entering')
                    } else if (elementChild.classList.contains('entering') && !elementChild.classList.contains('leaving') && element.isIntersecting === false) {
                        elementChild.classList.replace('entering', 'leaving')
                    }
                } else {
                    elementChild.classList.remove('leaving')
                }

            })
        }, {
            rootMargin: '-100px',
        })
        carObserver.observe(carImage.parentElement)
    }
})